import type * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../../utils/utils";
const badgeVariants = cva(
  "inline-flex items-center px-2.5 py-0.5 rounded-full font-semibold text-xs transition-colors",
  {
    variants: {
      variant: {
        default: "bg-[#A6FF4D] text-black border-black",
        secondary: "bg-white text-black border-black",
        outline: "bg-white text-black border-black border-[1px]  translate-y-[0px] translate-x-[1px]",
        "3d": "relative bg-white text-black border-black border-[1px] shadow-badge-3d transform translate-y-[-1px]",
        destructive: "bg-destructive text-destructive-foreground",
      },
      size: {
        default: "px-2.5 py-0.5 text-xs",
        sm: "px-2 py-0.5 text-[10px]",
        lg: "px-3 py-1 text-sm",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
);
export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  label?: string;
}
function Badge({
  className,
  variant,
  size,
  label,
  children,
  ...props
}: BadgeProps) {
  if (variant === "3d") {
    return (
      <div className="inline-block relative">
        {/* Shadow element */}
        <div className="top-[1px] left-[1px] absolute bg-black rounded-full w-full h-full" />
        {/* Badge element */}
        <div
          className={cn(badgeVariants({ variant, size }), className)}
          {...props}
        >
          {label || children}
        </div>
      </div>
    );
  }

  // For non-3d variants, render without shadow
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {label || children}
    </div>
  );
}

export { Badge, badgeVariants };
